import { apiObjUrl } from "src/common/apiUrl";
import { restWithObjectVersion } from "src/common/restWithObjectVersion";
import { ZAttribute, zAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { newItemId } from "src/pages/ManagementPage/Obj2Tab/Obj2Nodes";

export const loadFilterAttributes = async (
  attributeId: ZUid,
): Promise<ZAttribute[]> => {
  if (attributeId === newItemId) return [];
  const response = await restWithObjectVersion.get(
    apiObjUrl("/attributes/filter-attributes"),
    {
      params: { attributeId },
    },
  );
  return zAttribute.array().parse(response.data);
};
